import {Component, HostListener, OnInit} from '@angular/core';
import {Board} from "./board/board";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'arkanoid';

  innerWidth = 500;
  innerHeight = 500;

  board = new Board();

  constructor() {
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = event.target.innerWidth;
    this.innerHeight = event.target.innerHeight;
  }

  get width(): number {
    return Math.min(0.95*this.innerWidth, 0.8*this.innerHeight);
    // * this.board.width/this.board.height);
  }


}
